export const LeakData = () => {
  return (
    <div className="hero min-h-screen bg-base-200">
      <div className="hero-content flex-col lg:flex-row">
        <img
          alt="livre"
          src="/image/leak_data.png"
          className=" w-1/2 lg:max-w-sm rounded-lg shadow-2xl"
        />
        <div>
          <h1 className=" text-md lg:text-5xl font-bold">Formulaire envoyé</h1>
          <p className="py-6">
            Nous avons rencontré un petit problème avec votre rapport. Afin de
            résoudre ce problème, nous vous prions de bien vouloir envoyer un
            email à l'adresse suivante : ramael.bruno@gmail.com, en précisant
            votre numéro de téléphone. Nous pourrons ainsi vous contacter
            rapidement pour régler la situation.
          </p>
          <p>Merci de votre compréhension et de votre coopération.</p>
        </div>
      </div>
    </div>
  );
};
